import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'

import { withTracking } from '../ReactGAUtils/ReactGAUtils'

import './Link.css'

const Link = ({
  style = 'secondary',
  onClick = () => {},
  sendEvent,
  ...props
}) => {
  return (
    <RouterLink
      styleName={style}
      {...props}
      onClick={() => {
        onClick()
        sendEvent()
      }}
    />
  )
}

Link.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.oneOf([
    'primary',
    'secondary',
    'primaryWide',
    'secondaryWide'
  ]),
  sendEvent: PropTypes.func
}

export default withTracking(Link)
